import React from 'react'
import ForDetail from '../components/ForDetail'
import { sirketHaberleri } from '../data/sirket-haberleri'
import { Link } from 'react-router'
import NewsComponent from '../components/NewsComponent'

const SirketHaberleri = () => {
        const title ='Şirket Haberleri'
    return (
        <div className=''>
            <NewsComponent data={sirketHaberleri} title={title} />
        </div>
    )
}

export default SirketHaberleri